<template>
  <v-flex class="pl-2 pr-2 pb-2">
    <v-layout align-start justify-start row class="mb-4">
      <v-icon color="primary" style="font-size: 50px">group</v-icon>
      <h2 :style="`color: ${$vuetify.theme.primary}`" class="mt-2">
        {{ $translate("USER_ROLES") }}
      </h2>
      <v-spacer></v-spacer>

      <v-btn fab right color="secondary" @click="newItem">
        <v-icon>add</v-icon>
      </v-btn>
    </v-layout>

    <v-spacer></v-spacer>
    <v-data-table
      :headers="headers"
      :items="roles"
      class="elevation-1"
      :rows-per-page-items="[10]"
    >
      <template v-slot:items="props">
        <td>{{ props.item.Description }}</td>
        <td class="text-xs-right">{{ props.item.PartnerName }}</td>
        <td>
          <v-checkbox
            :input-value="props.item.Global"
            class="justify-center"
            hide-details
            disabled
          ></v-checkbox>
        </td>
        <td class="justify-center">
          <v-btn
            small
            :disabled="props.item.Global"
            class="v-btn-tiny mr-2"
            color="primary"
            @click="editItem(props.item)"
          >
            <v-icon small>edit</v-icon>
          </v-btn>

          <v-btn
            small
            :disabled="props.item.Global"
            class="v-btn-tiny mr-2"
            color="primary"
            @click="deleteItem(props.item)"
          >
            <v-icon small>delete</v-icon>
          </v-btn>
        </td>
      </template>
    </v-data-table>

    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">{{
            $translate("DELETE_USER_ROLE_TITLE")
          }}</span>
        </v-card-title>

        <v-card-text>
          <v-layout wrap>
            <v-flex xs12>
              <v-text-field
                disabled
                v-model="roleSelected.Description"
                :label="$translate('ACCOUNT_USER_ROLE_DESCRIPTION')"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="secondary darken-1"
            round
            @click="dialogDelete = false"
            >{{ $translate("CANCEL") }}</v-btn
          >
          <v-btn
            color="primary darken-1"
            :disabled="deleteDisable"
            :loading="deleteDisable"
            round
            @click="deleteUserRole"
            >{{ $translate("DELETE") }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog" max-width="500px">
      <v-card class="round_dialog_roles">
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>
        </v-card-title>

        <v-card-text>
          <v-form ref="UserRoleForm" v-model="valid" lazy-validation>
            <v-layout row wrap justify-space-around>
              <v-flex xs5>
                <v-text-field
                  v-model="roleSelected.Description"
                  :rules="textRules"
                  :label="$translate('ACCOUNT_USER_ROLE_DESCRIPTION')"
                ></v-text-field>
              </v-flex>
              <v-flex xs5>
                <v-select
                  v-model="partnerSelected"
                  :items="partnerList"
                  item-text="Name"
                  item-value="PartnerId"
                  label="Partner of User Role"
                  return-object
                ></v-select>
              </v-flex>
            </v-layout>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary darken-1" round @click="dialog = false">{{
            $translate("CANCEL")
          }}</v-btn>
          <v-btn color="primary darken-1" round @click="saveUserRole">{{
            $translate("SAVE")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-flex>
</template>

<script>
import ImageLoader from "@/components/media/ImageLoader";
import AudioLoader from "@/components/media/AudioLoader";
import * as dssRequest from "@/api/dssRequest";
import appConfig from "../../../config/app_config";
import BaseObject from "@/objects/BaseObject";
import { Sketch } from "vue-color";
import _ from "lodash";
import { mapGetters } from "vuex";
import BaseComponent from "../base/BaseComponent.vue";
import { optionalTextRulesTo32 } from "@/shared/validations_rules";

export default {
  extends: BaseComponent,
  name: "AccountRoles",
  components: {
    AudioLoader,
    ImageLoader,
    "sketch-picker": Sketch,
  },
  props: {
    partners: {
      type: Array,
      default: [],
    },
  },
  computed: {
    editMode() {
      if (
        this.roleSelected.hasOwnProperty("UserRoleId") &&
        this.roleSelected.UserRoleId !== undefined &&
        this.roleSelected.UserRoleId !== ""
      ) {
        return true;
      } else {
        return false;
      }
    },
    formTitle() {
      if (this.editMode) {
        return this.$translate("ACCOUNT_EDIT_USER_ROLE");
      } else {
        return this.$translate("ACCOUNT_NEW_USER_ROLE");
      }
    },
    userGroupId() {
      if (this.PartnerId != undefined && Number(this.PartnerId) > -1) {
        return this.currentAccountId + "_UG_" + this.PartnerId;
      } else {
        return this.currentAccountId;
      }
    },
  },
  data() {
    return {
      valid: true,
      dialogDelete: false,
      deleteDisable: false,
      dialog: false,
      roles: [],
      roleSelected: {},
      partnerList: [],
      partnerSelected: {},
      disableButton: true,
      textRules: optionalTextRulesTo32,
      headers: [
        {
          text: this.$translate("ACCOUNT_USER_ROLE_DESCRIPTION"),
          align: "left",
          sortable: true,
          value: "Description",
        },
        {
          text: this.$translate("ACCOUNT_USER_ROLE_PARTNER"),
          align: "left",
          sortable: true,
          value: "PartnerName",
        },
        {
          text: this.$translate("ACCOUNT_USER_ROLE_GLOBAL"),
          align: "left",
          sortable: true,
          value: "Global",
        },
        {
          text: "",
          align: "left",
          sortable: false,
          value: "",
        }
      ],
    };
  },
  mounted() {
    // Init partner list
    let emptyPartner = {};
    emptyPartner.PartnerId = -1;
    emptyPartner.Name = "None";
    this.partnerList.push(emptyPartner);
    this.partnerList = this.partnerList.concat(this.partners);

    this.getUserRoles();
  },
  methods: {
    getUserRoles() {
      let payload = {};
      dssRequest.doRequest(
        (response) => {
          console.log(
            "The call [getUserRoles] on UserGroup [%s] in component [Account_Roles] succeeded",
            this.userGroupId,
            response
          );
          // Clear current roles array
          this.roles = [];

          if (response.data.hasOwnProperty("UserRoles") && response.data.UserRoles !== undefined) {
            this.roles = response.data.UserRoles;
          }

          // Update User Roles in store
          this.$store.commit("setUserRolesFromUserGroup", this.roles);
        },
        (error) => {
          console.log(
            "The call [getUserRoles] on UserGroup [%s] in component [Account_Roles] failed",
            this.userGroupId,
            error
          );
        },
        "getUserRoles",
        this.userGroupId,
        payload
      );
    },
    saveUserRole() {
      this.roleSelected.PartnerId = this.partnerSelected.PartnerId;

      if(this.editMode) {
        this.editUserRole();
      }
      else {
        this.createUserRole();
      }
    },
    createUserRole() {
      const payload = {
        Description: this.roleSelected.Description,
        PartnerId: this.roleSelected.PartnerId
      };
      dssRequest.doRequest(
        (response) => {
          console.log(
            "The call [createUserRole] on UserGroup [%s] in component [Account_Roles] succeeded",
            this.userGroupId,
            response
          );
          this.close();
          this.getUserRoles();
        },
        (error) => {
          console.log(
            "The call [createUserRole] on UserGroup [%s] in component [Account_Roles] failed",
            this.userGroupId,
            error
          );
          this.close();
        },
        "createUserRole",
        this.userGroupId,
        payload
      );
    },
    editUserRole() {
      const payload = {
        UserRoleId: this.roleSelected.UserRoleId,
        Description: this.roleSelected.Description,
        PartnerId: this.roleSelected.PartnerId
      };
      dssRequest.doRequest(
        (response) => {
          console.log(
            "The call [editUserRole] on UserGroup [%s] in component [Account_Roles] succeeded",
            this.userGroupId,
            response
          );
          this.close();
          this.getUserRoles();
        },
        (error) => {
          console.log(
            "The call [editUserRole] on UserGroup [%s] in component [Account_Roles] failed",
            this.userGroupId,
            error
          );
          this.close();
        },
        "editUserRole",
        this.userGroupId,
        payload
      );
    },
    close() {
      this.dialog = false;
      this.roleSelected = {};
    },
    newItem() {
      // Init new user role
      this.partnerSelected = this.partnerList[0];
      this.roleSelected.Description = "";
      this.roleSelected.PartnerId = this.partnerSelected.PartnerId;

      this.dialog = true;
      this.$refs.UserRoleForm.resetValidation();
    },
    editItem(item) {
      this.roleSelected = Object.assign({}, item);

      // Locate corresponding partner for selected user role in partnerList
      this.partnerSelected = this.partnerList.find(
        partner => String(partner.PartnerId) === String(this.roleSelected.PartnerId)
      );

      this.dialog = true;
    },
    deleteItem(item) {
      this.roleSelected = Object.assign({}, item);
      this.dialogDelete = true;
    },
    deleteUserRole() {
      this.deleteDisable = true;
      const payload = {
        UserRoleId: this.roleSelected.UserRoleId,
      };

      dssRequest.doRequest(
        (response) => {
          console.log(
            "The call [deleteUserRole] on UserGroup [%s] in component [Account_Roles] succeeded",
            this.userGroupId,
            response
          );
          this.deleteDisable = false;
          this.dialogDelete = false;
          this.roleSelected = {};
          this.getUserRoles();
        },
        (error) => {
          console.log(
            "The call [deleteUserRole] on UserGroup [%s] in component [Account_Roles] failed",
            this.userGroupId,
            error
          );
          this.deleteDisable = false;
          this.dialogDelete = false;
          this.roleSelected = {};
        },
        "deleteUserRole",
        this.userGroupId,
        payload
      );
    },
  },
};
</script>
